import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory, Link } from 'react-router';

import { Menu, MenuItem, RootRef, withStyles, WithStyles } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { includes, map } from 'lodash';

import { selectCurrentMasterSettings } from '@lib/selectors';

import { Button, Typography } from 'components/v2';
import { isUsingOutreachExperience } from 'utils/outreachExperience';

import { BreadcrumbStep } from '../Breadcrumb.utils';

import { useStyles } from './BreadcrumbSelect.useStyles';

export interface BreadcrumbSelectProps extends WithStyles<typeof useStyles>, BreadcrumbStep {}

const BreadcrumbSelect: React.FC<BreadcrumbSelectProps> = ({ classes, menu, path, label }) => {
  const settings = useSelector(selectCurrentMasterSettings);
  const isToUseOutreachExperience = isUsingOutreachExperience(settings);
  const anchorRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <RootRef rootRef={anchorRef}>
        <>
          <Button
            onClick={() => browserHistory.push(includes(path, 'form-builder') ? '/v2/form-builder' : path)}
            className={classes.labelButton}
            type="button"
            size="small"
            variant="outlined"
            color="primary"
            disabled={path === ''}
            rounded
          >
            <Typography variant="h3W500F15" color="primary">
              {isToUseOutreachExperience && label === 'Inbound Referral' ? 'Outreach' : label}
            </Typography>
          </Button>
          <Button
            onClick={() => setAnchorEl(anchorRef.current)}
            className={classes.selectButton}
            type="button"
            size="small"
            variant="outlined"
            color="primary"
            rounded
          >
            <Typography variant="bW600F12" color="primary">
              {anchorEl ? <ArrowDropUp /> : <ArrowDropDown />}
            </Typography>
          </Button>
        </>
      </RootRef>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        disableAutoFocusItem
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: -23,
          horizontal: 0,
        }}
      >
        {map(
          menu,
          (menuItem) =>
            !!menuItem.path && (
              <Link
                to={menuItem.key === 'form-builder' ? '/v2/form-builder' : menuItem.path}
                className={classes.link}
                key={menuItem.key}
              >
                <MenuItem onClick={() => setAnchorEl(null)}>
                  <Typography variant="h3W500F15" className={classes.listItemText}>
                    {isToUseOutreachExperience && menuItem.label === 'Inbound Referral' ? 'Outreach' : menuItem.label}
                  </Typography>
                </MenuItem>
              </Link>
            ),
        )}
      </Menu>
    </>
  );
};

export default withStyles(useStyles)(BreadcrumbSelect);
